import { useEffect } from 'react';
import buildVanDashboardStyles, { STYLE_ELEMENT_ID } from '../styles';

export function useInjectStyles() {
  useEffect(() => {
    let styleElement = document.getElementById(STYLE_ELEMENT_ID);

    if (!styleElement) {
      styleElement = document.createElement('style');
      styleElement.id = STYLE_ELEMENT_ID;
      document.head.appendChild(styleElement);
    }

    styleElement.textContent = buildVanDashboardStyles();
  }, []);
}
